import Navbar from "../../../components/Navbar/Navbar";
import PaymentForm from "../components/PaymentForm/PaymentForm";

export default function PaymentPage() {
    return (
        <>
            <Navbar title="Payments" />
            <PaymentForm />
        </>
    );
}
